// let isAtBottom = false;
// let isButtonPassed = false;

// const checkElementVisibility = () => {
// const buttonElement = document.querySelector('.product-form__buttons');
// const fixedCartDetail = document.querySelector('.fixed_cart_detail');

// if (!buttonElement || !fixedCartDetail) return;

// const buttonRect = buttonElement.getBoundingClientRect();
// const viewportHeight = window.innerHeight;
// const documentHeight = document.documentElement.scrollHeight;
// const scrollTop = window.scrollY;

// isButtonPassed = buttonRect.bottom < 0;

// const atBottom = scrollTop + viewportHeight >= documentHeight;

// if (isButtonPassed && !atBottom) {
//     fixedCartDetail.style.bottom = '0px';
// } else if (atBottom) {
//     fixedCartDetail.style.bottom = '-150px';
// } else {
//     fixedCartDetail.style.bottom = '-150px';
// }
// };

// window.addEventListener('scroll', () => {
// requestAnimationFrame(checkElementVisibility);
// });

// checkElementVisibility();

let isAtBottom = false;
let isButtonPassed = false;

const checkElementVisibility = () => {
  const buttonElement = document.querySelector('.product-form__buttons');
  const fixedCartDetail = document.querySelector('.fixed_cart_detail');

  if (!buttonElement || !fixedCartDetail) return;

  const buttonRect = buttonElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;
  const scrollTop = window.scrollY;

  // product-form__buttons がビューポートを上に通り過ぎたかをチェック
  isButtonPassed = buttonRect.bottom < 0;

  // ページの一番下にいるかどうかをチェック
  const atBottom = scrollTop + viewportHeight >= documentHeight;

  if (isButtonPassed && !atBottom) {
    fixedCartDetail.style.bottom = '0px'; // 表示
  } else {
    fixedCartDetail.style.bottom = '-150px'; // 非表示
  }
};

window.addEventListener('scroll', () => {
  requestAnimationFrame(checkElementVisibility);
});

checkElementVisibility();